require 'requestidlecallback-polyfill'

console.log "прЮвет ВОЛКУ!"

global.HM ||= {}

HM.is_touch = !!navigator.userAgent.match(/Mobi/)
HM.is_mobile = screen.width <= 700 || (window.matchMedia && window.matchMedia('only screen and (max-width: 700px)').matches)
HM.is_apple = /iPad|iPhone|iPod/.test(navigator.userAgent)
document.addEventListener 'DOMContentLoaded', ->
  document.body.classList.add('mobile') if HM.is_mobile
  document.body.classList.add('apple') if HM.is_apple

HM.env            = process.env.NODE_ENV || 'development'
HM.is_development = HM.env == 'development'
HM.is_production  = HM.env == 'production'
HM.is_demo        = location.hostname.includes('demo.')
HM.promo_site_url = location.protocol + '//' + location.host.replace(/app\.|demo\./, '')
HM.promo_site_url = HM.promo_site_url.replace '8080', '8090'
HM.app_url        = location.protocol + '//app.' + location.host.replace(/app\.|demo\.|www\./, '')
HM.demo_url       = HM.app_url.replace('app.', 'demo.')

HM.last_deploy_time = __LAST_DEPLOY_TIME__

host = location.hostname
HM.locale = 'en'
HM.locale = 'ru' if host.includes('ru.test') || host.includes('hmbee') || location.pathname.includes('/ru') || host.includes('hm3.netlify')
HM.is_russian = HM.locale == 'ru'
HM.is_english = HM.locale == 'en'

# Require only after HM.locale is set
global.hm_date = require('models/hm_date.coffee')

####### Analytics ########
HM.track = (event, payload = '') ->
  return if HM.is_demo
  if HM.is_development
    log.warning "----TRACK: #{event}", payload
  else
    window.Intercom 'trackEvent', event, (payload || {})
    mixpanel.track(event, payload) if window.mixpanel
    window.yaCounter46124181.reachGoal(event, payload) if window.yaCounter46124181
    window.yaCounter17133895.reachGoal(event, payload) if window.yaCounter17133895
HM.intercom = (event) -> window.Intercom(event) if window.Intercom

HM.track_signup = (attrs) ->
  HM.identify { email: attrs.email }
  HM.track "signed up"
  $FPROM.trackSignup({email: attrs.email, first_name: attrs.first_name}) if window.$FPROM && $FPROM.trackSignup

HM.closeAnalytics = -> window.Intercom("shutdown")

HM.identify = (attrs) ->
  return if HM.is_demo
  if window.Intercom
    attrs.custom_launcher_selector = '.intercom_launcher' if HM.is_mobile
    attrs.hide_default_launcher = HM.is_mobile
    attrs.alignment = 'right'
    attrs.horizontal_padding = 20
    attrs.vertical_padding = 20
    window.Intercom("boot", attrs)

  if HM.is_development
    log.warning "IDENTIFY", attrs.email
  else
    if window.FS
      FS.identify attrs.user_id, { displayName: attrs.email, email: attrs.email }
    if window.mixpanel
      mixpanel.identify        attrs.email
      mixpanel.name_tag        attrs.email
      mixpanel.people.identify(attrs.email) if mixpanel.people.identify
      mixpanel.people.set      { $email: attrs.email }
    if window.ga
      ga('set', 'userId', attrs.email)
    # if window.amplitude
    #   amplitude.init('f4131d0f9b547592b8d6af75bac1a7c3', attrs.email)
    #   identify = new amplitude.Identify()
    #   identify.set 'created_at',       attrs.created_at
    #   identify.set 'default_currency', attrs.default_currency
    #   identify.set 'paid_till',        attrs.paid_till
    #   identify.set 'name',             attrs.name
    #   identify.set 'transactions',     attrs.transactions
    #   identify.set 'accounts',         attrs.accounts
    #   identify.set 'virtuals',         attrs.virtuals
    #   identify.set 'total_revenue',    attrs.total_revenue
    #   amplitude.identify identify

#  Intercom
SetupIntercom = ->
  `
  (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',intercomSettings);}else{var d=document;var i=function(){i.c(arguments)};i.q=[];i.c=function(args){i.q.push(args)};w.Intercom=i;function l(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/974a8191da43e647a2b0e55ef1c28fa11454e72f';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);}if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})()
  `
  return true # need it here, otherwise the function doesn't work

if HM.is_russian
  SetupIntercom()
  if !HM.is_development
    `
      // Yandex.Metrika
      (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)}; m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)}) (window, document, "script", "https://cdn.jsdelivr.net/npm/yandex-metrica-watch/tag.js", "ym"); ym(17133895, "init", { clickmap:true, trackLinks:true, accurateTrackBounce:true, trackHash:true });
      //
      //
      // Mixpanel
      (function(e,b){if(!b.__SV){var a,f,i,g;window.mixpanel=b;a=e.createElement("script");a.type="text/javascript";a.async=!0;a.src=("https:"===e.location.protocol?"https:":"http:")+'//cdn.mxpnl.com/libs/mixpanel-2.2.min.js';f=e.getElementsByTagName("script")[0];f.parentNode.insertBefore(a,f);b._i=[];b.init=function(a,e,d){function f(b,h){var a=h.split(".");2==a.length&&(b=b[a[0]],h=a[1]);b[h]=function(){b.push([h].concat(Array.prototype.slice.call(arguments,0)))}}var c=b;"undefined"!== typeof d?c=b[d]=[]:d="mixpanel";c.people=c.people||[];c.toString=function(b){var a="mixpanel";"mixpanel"!==d&&(a+="."+d);b||(a+=" (stub)");return a};c.people.toString=function(){return c.toString(1)+".people (stub)"};i="disable track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config people.set people.increment people.append people.track_charge people.clear_charges people.delete_user".split(" ");for(g=0;g<i.length;g++)f(c,i[g]);b._i.push([a,e,d])};b.__SV=1.2}})(document,window.mixpanel||[]);
      mixpanel.init("b2e27344d3c82fd16cf07e54a353fe48");
      //
      //
      // Google Analytics
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
      ga('create', 'UA-3772237-6', 'auto');
      ga('send', 'pageview');
    `

if HM.is_english
  SetupIntercom()
  if !HM.is_development
    `
      // Yandex.Metrika
      (function (d, w, c) { (w[c] = w[c] || []).push(function() { try { w.yaCounter46124181 = new Ya.Metrika({ id:46124181, clickmap:true, trackLinks:true, accurateTrackBounce:true, webvisor:true, trackHash:true, ecommerce:"dataLayer" }); } catch(e) { } }); var n = d.getElementsByTagName("script")[0], s = d.createElement("script"), f = function () { n.parentNode.insertBefore(s, n); }; s.type = "text/javascript"; s.async = true; s.src = "https://cdn.jsdelivr.net/npm/yandex-metrica-watch/watch.js"; if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); } })(document, window, "yandex_metrika_callbacks");
      //
      //
      // Mixpanel
      (function(e,a){if(!a.__SV){var b=window;try{var c,l,i,j=b.location,g=j.hash;c=function(a,b){return(l=a.match(RegExp(b+"=([^&]*)")))?l[1]:null};g&&c(g,"state")&&(i=JSON.parse(decodeURIComponent(c(g,"state"))),"mpeditor"===i.action&&(b.sessionStorage.setItem("_mpcehash",g),history.replaceState(i.desiredHash||"",e.title,j.pathname+j.search)))}catch(m){}var k,h;window.mixpanel=a;a._i=[];a.init=function(b,c,f){function e(b,a){var c=a.split(".");2==c.length&&(b=b[c[0]],a=c[1]);b[a]=function(){b.push([a].concat(Array.prototype.slice.call(arguments, 0)))}}var d=a;"undefined"!==typeof f?d=a[f]=[]:f="mixpanel";d.people=d.people||[];d.toString=function(b){var a="mixpanel";"mixpanel"!==f&&(a+="."+f);b||(a+=" (stub)");return a};d.people.toString=function(){return d.toString(1)+".people (stub)"};k="disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" "); for(h=0;h<k.length;h++)e(d,k[h]);a._i.push([b,c,f])};a.__SV=1.2;b=e.createElement("script");b.type="text/javascript";b.async=!0;b.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:"file:"===e.location.protocol&&"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)?"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";c=e.getElementsByTagName("script")[0];c.parentNode.insertBefore(b,c)}})(document,window.mixpanel||[]);
      mixpanel.init("74c22e9176629f0e3f2d9c583a92177a");
    `
